var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Brand, Type, Environment, GenericError } from '@lendi/lala-utils';
import { Session } from './Session';
import { Status, } from './types';
var mockSessionOptions = {
    brand: Brand.Lendi,
    type: Type.Customer,
    environment: Environment.Production,
};
export var mockIdentity = {
    id: 'mock-identity-id',
};
export var VerifyCodeResult;
(function (VerifyCodeResult) {
    VerifyCodeResult[VerifyCodeResult["Authenticated"] = 0] = "Authenticated";
    VerifyCodeResult[VerifyCodeResult["Errored"] = 1] = "Errored";
    VerifyCodeResult[VerifyCodeResult["Denied"] = 2] = "Denied";
})(VerifyCodeResult || (VerifyCodeResult = {}));
/**
 * MockSession provides access to private Session properties
 *
 * @export
 * @class MockSession
 * @extends {Session}
 */
var MockSession = /** @class */ (function (_super) {
    __extends(MockSession, _super);
    /**
     * Creates an instance of MockSession.
     * Default session options are Lendi-Customer-Production
     * @param {SessionOptions} [options=mockSessionOptions]
     * @memberof MockSession
     */
    function MockSession(options, identity) {
        if (options === void 0) { options = mockSessionOptions; }
        if (identity === void 0) { identity = mockIdentity; }
        var _this = _super.call(this, __assign(__assign({}, options), { forceRefresh: true })) || this;
        _this._verifyResult = VerifyCodeResult.Authenticated;
        _this._identity = identity;
        return _this;
    }
    Object.defineProperty(MockSession.prototype, "emitter", {
        get: function () {
            return this._emitter;
        },
        enumerable: false,
        configurable: true
    });
    MockSession.prototype.setStatus = function (status) {
        this._status = status;
    };
    MockSession.prototype.setExpiry = function (expiry) {
        this._expiry = expiry;
    };
    MockSession.prototype.setToken = function (token) {
        this._token = token;
    };
    Object.defineProperty(MockSession.prototype, "error", {
        get: function () {
            return this._error;
        },
        enumerable: false,
        configurable: true
    });
    MockSession.prototype.setError = function (error) {
        this._error = error;
    };
    Object.defineProperty(MockSession.prototype, "verifyResult", {
        set: function (result) {
            if (this._error === undefined)
                this._error = new GenericError();
            this._verifyResult = result;
        },
        enumerable: false,
        configurable: true
    });
    MockSession.prototype.clearExpiry = function () {
        if (this._status === Status.Expired) {
            this._status = Status.Unauthenticated;
        }
    };
    MockSession.prototype.sendCode = function (phoneNumber) {
        if (phoneNumber === void 0) { phoneNumber = '123456'; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    MockSession.prototype.verifyCode = function (_a) {
        var _b = _a === void 0 ? {
            phone: '123456',
            code: '654321',
            email: 'ab@cd.ef',
        } : _a, phone = _b.phone, code = _b.code, email = _b.email;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                if (this._verifyResult === VerifyCodeResult.Errored) {
                    return [2 /*return*/, Promise.reject(this.error)];
                }
                return [2 /*return*/, Promise.resolve({ valid: this._verifyResult === VerifyCodeResult.Authenticated })];
            });
        });
    };
    MockSession.prototype.popupAuthorise = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._error) {
                    return [2 /*return*/, Promise.reject(this._error)];
                }
                return [2 /*return*/, Promise.resolve(this._token ? { existingCustomer: false, token: this._token } : undefined)];
            });
        });
    };
    MockSession.prototype.popupAuthoriseWithoutSetSession = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._error) {
                    return [2 /*return*/, Promise.reject(this._error)];
                }
                return [2 /*return*/, Promise.resolve(this._token ? { token: this._token, idTokenPayload: {} } : undefined)];
            });
        });
    };
    return MockSession;
}(Session));
export { MockSession };
//# sourceMappingURL=MockSession.js.map